import { useLocation } from '@tanstack/react-router'
import { ArrowLeftIcon, MinusIcon } from 'lucide-react'

import { ButtonIcon } from '@/ui/atoms/button/Button'
import { InternalLinkButton } from '@/ui/atoms/link-button/LinkButton'
import { NetworkBadge } from '@/ui/atoms/network-badge/NetworkBadge'

interface BackNavProps {
  chainId: number
}

export function BackNav({ chainId }: BackNavProps) {
  const { state } = useLocation()

  const backInfo = (() => {
    if (state.from === '/my-portfolio') {
      return {
        text: 'Back to My Portfolio',
        path: '/my-portfolio' as const,
      }
    }

    return {
      text: 'Back to Markets',
      path: '/markets' as const,
    }
  })()

  return (
    <div className="flex items-center gap-1 px-3 sm:px-0">
      <InternalLinkButton to={backInfo.path} variant="transparent" size="s">
        <ButtonIcon icon={ArrowLeftIcon} />
        {backInfo.text}
      </InternalLinkButton>
      <MinusIcon className="rotate-90 text-neutral-200" />
      <NetworkBadge chainId={chainId} />
    </div>
  )
}
